import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Carousel } from "react-bootstrap";
import { Image } from "cloudinary-react";
import Loader from "../../components/loader";
import Message from "../../components/message";
import { fetchLatestProducts } from "../../actions/product";

const ProductCarousel = () => {
  const dispatch = useDispatch();

  // Latest Product Reducer
  const latestProducts = useSelector((state) => state.latestProducts);
  const { loading, latestProducts: products, error } = latestProducts;

  useEffect(() => {
    if (!products) {
      dispatch(fetchLatestProducts());
    }
  }, [dispatch, products]);

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const marketingLines = [
    "Discover cutting-edge mobile technology designed to elevate your lifestyle.",
    "Premium smartphones at prices that make sense. Why settle for less?",
    "Powerful performance, sleek designs, and the latest features—only at Datacom.",
  ];

  return loading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error}</Message>
  ) : products ? (
    <Carousel
      pause="hover"
      indicators={false}
      controls={true}
      activeIndex={index}
      onSelect={handleSelect}
      style={{
        background: "#EDF1F3",
        padding: "20px 0",
      }}
    >
      {products.map((product, index) => {
        return (
          <Carousel.Item key={product._id}>
            <div class="container">
              <div class="row d-flex align-items-center">
                <div class="col-md-6">
                  <div class="banner-content">
                    <h1
                      class="text-uppercase pb-5 fw-light"
                      style={{
                        fontSize: "3rem",
                        color: "#212529",
                        fontWeight: 300,
                      }}
                    >
                      {marketingLines[index]}
                    </h1>
                    <button
                      className="btn btn-medium btn-dark text-uppercase btn-rounded-none"
                      style={{
                        position: "relative",
                        zIndex: 3,
                        backgroundColor: "#212529",
                        color: "white",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#514f4f";
                        e.target.style.color = "white";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "black";
                        e.target.style.color = "white";
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        const section =
                          document.getElementById("mobileListing");
                        if (section) {
                          section.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                          });
                        }
                      }}
                    >
                      Shop Product
                    </button>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    class="image-holder"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Image
                      cloudName="dljielsye"
                      class="carousel-img"
                      publicId={product.image[0]}
                      style={{
                        maxWidth: "100%",
                        height: "500px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>
        );
      })}
    </Carousel>
  ) : (
    <></>
  );
};

export default ProductCarousel;
